import { useState } from 'react';
// @mui
import { Box, MenuItem, Stack, Popover } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Flags from 'country-flag-icons/react/3x2';
import config from "../../../config";
import helper from "../../../utils/helper";
import i18n from "../../../i18n";
import {
    FlagBox,
    LanguageTrigger,
    languageCaretSx,
    languageMetaSx,
    menuPaperSx
} from './headerTriggers.styles';


// ----------------------------------------------------------------------

const langs = config.langs.map(it => {
    const FlagTag = Flags[it.iconKey];

    return { ...it, icon: FlagTag ? <FlagTag title={it.label} /> : null };
});

// ----------------------------------------------------------------------

export default function LanguagePopover() {
    let [open, setOpen] = useState(null);

    const handleOpen = ev => {
        setOpen(ev.currentTarget);
    };

    const handleClose = lang => {
        setOpen(null);

        if (langs.find(l => l.value === lang)) {
            helper.changeLanguage(lang);
        }
    };

    const selectedLanguage = langs.find(l => l.value === i18n.resolvedLanguage)
        || langs.find(l => l.value === config.language)
        || langs[0];

    if (!selectedLanguage) {
        return null;
    }

    return (
        <>
            {/* Flag, code and caret: the flag alone did not say it was the
                language switch, nor which language. */}
            <LanguageTrigger
                open={Boolean(open)}
                onClick={handleOpen}
                aria-label={selectedLanguage.label}
                aria-haspopup="true"
                aria-expanded={Boolean(open)}
            >
                <FlagBox>{selectedLanguage.icon}</FlagBox>
                <Box component="span" sx={languageMetaSx}>
                    {selectedLanguage.value.toUpperCase()}
                </Box>
                <KeyboardArrowDownIcon sx={languageCaretSx} />
            </LanguageTrigger>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { sx: menuPaperSx(200) } }}
            >
                <Stack spacing={0.25}>
                    {langs.map((option) => (
                        <MenuItem
                            key={option.value}
                            selected={option.value === selectedLanguage.value}
                            onClick={() => handleClose(option.value)}
                        >
                            <FlagBox sx={{ mr: 1.5 }}>{option.icon}</FlagBox>
                            {option.label}
                        </MenuItem>
                    ))}
                </Stack>
            </Popover>
        </>
    );
}
